import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

import COVER from '@/utils/COVER'
import COVERAPP from '@/utils/COVERAPP'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		aid: process.env.VUE_APP_ENV == 'test' ? '64c755dbedd94d004347b6dd' : '6514df9a0ce39c004affde98', //活动id
		newsId: process.env.VUE_APP_ENV == 'test' ? 2449782 : 11007269,
		isApp: false, //是否在app中
		versionSize: 0, //app版本
		serverTime: 0, // 服务器时间
		userinfo: {
      /* "device_id" : "72dd0db6-7345-3067-9eb6-6c16295cf279-CQDD",
      "push_id" : "cc1f65b8ffcf41109618e6a390f6f36f",
      "status" : "success",
      "account_id" : 0,
      "age" : 0,
      "birthday" : 0,
      "city" : "",
      "email" : "",
      "gender" : "null",
      "integral_sum" : 0,
      "is_lock" : false,
      "is_news" : false,
      "is_qq" : false,
      "is_unique_way" : false,
      "is_wechat" : false,
      "is_weibo" : false,
      "label_kind" : 0,
      "mobile" : "19138481976",
      "nickname" : "fm7afeb1",
      "register_way" : 9,
      "token" : "d091f02bc4ef4e06aa77d21b9fcb5fe8",
      "user_id" : 49010309,
      "user_name" : "3XkvhUyu5+W16dhINNbjVA==",
      "origin" : "app",
      "avatar" : "https://wapcdn.thecover.cn/wap/4.2.1/images/user_default.png" */
    }, //用户信息
		shareData: {},//分享信息
		maskData: null, //弹框信息
		hbFlagData: null, //获得红包弹窗是否显示
		toastData: null, //toast数据
		resultData: null, //结果页数据
		pageLoading: true, //页面是否加载中
		isImmerse: false, //是否沉浸式
		activityData: null,
		topicData: { //话题数据
			'2019': {
				'id': process.env.VUE_APP_ENV == 'test' ? 21373 : 2916,
				'title': '阖家团圆 分享节日幸福时刻',
				'options': [
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271tp31tfs52b38g18hu4a.png',
						'desc': '分享环保心得',
						'text': '双节同庆，一定要开开心心的哟。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27681i45nk3s2h15ka4b.png',
						'desc': '立个存钱flag',
						'text': '双节同庆，好运连连，生活比蜜甜。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271bra1ulug6vo2d1krb4c.png',
						'desc': '写下生活记录',
						'text': '有种幸福是中秋遇上国庆，畅快耍假期。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27tkg13ij1epuha41oqu4d.png',
						'desc': '聊聊你的爱情',
						'text': '皓月当空，佳节愉快，团圆美满。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27sjd4261l8k2bsadj4e.png',
						'desc': '说说忙碌时光',
						'text': '祝福祖国繁荣昌盛，祝自己越来越好。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271tje11n3l162um1aj74f.png',
						'desc': '写个旅行规划',
						'text': '中秋加国庆，好事成双，好运连连。',
					},
          {
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271tp31tfs52b38g18hu4a.png',
						'desc': '分享环保心得',
						'text': '幸福双双至，快乐喜相连。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27681i45nk3s2h15ka4b.png',
						'desc': '立个存钱flag',
						'text': '全家团聚庆双节，美酒飘香传四方。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271bra1ulug6vo2d1krb4c.png',
						'desc': '写下生活记录',
						'text': '月圆合家欢，家庭和睦暖人间。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27tkg13ij1epuha41oqu4d.png',
						'desc': '聊聊你的爱情',
						'text': '秋高气爽迎双节，花好月圆幸福甜。',
					},
				]
			},
			'2020': {
				'id': process.env.VUE_APP_ENV == 'test' ? 21454 : 2917,
				'title': '旅行日记 定格旅行精彩瞬间',
				'options': [
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27dbu13b81ni2164n15094h.png',
						'desc': '写个旅行计划',
						'text': '热爱漫无边际，漫步山水之间。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm28pku1ncn1v9udch6n4i.png',
						'desc': '幻想发个大财',
						'text': '晨光初照，山花烂漫，都在旅行路上。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm281v3hm8ploeeq611g54j.png',
						'desc': '许个脱单心愿',
						'text': '在自由自在的路上，寻找心灵的归宿。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm28kkp9i51ufi3kn214k.png',
						'desc': '说说买房愿望',
						'text': '于漫山遍野之间，留下自由轻快的脚步。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm28bkj1hke1ps6bntf5t4l.png',
						'desc': '立个减肥flag',
						'text': '去不同的城市，感受不一样的人间烟火。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm28nub18ck1epljcn1h4l4m.png',
						'desc': '聊聊运动计划',
						'text': '诗和远方，都在行走的路上。',
					},
          {
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27dbu13b81ni2164n15094h.png',
						'desc': '写个旅行计划',
						'text': '祖国的大好河山，应该去看一看的。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm28pku1ncn1v9udch6n4i.png',
						'desc': '幻想发个大财',
						'text': '沿途的风景里，有只属于旅行者的印记。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm281v3hm8ploeeq611g54j.png',
						'desc': '许个脱单心愿',
						'text': '最好的时光在路上，最美的风景在脚下。',
					},
					{
						'title': '畅耍双节',
						'img': 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm28kkp9i51ufi3kn214k.png',
						'desc': '说说买房愿望',
						'text': '仰望大漠苍穹，品味江南烟雨朦胧。',
					},
				]
			}
		},
		blessArr: [
			'从前不回头，以后不将就。2020做最酷的养生年轻人！',
			'幸福多一点，幸运多一分，2020愿你有钱有闲有朋友。',
			'脱个单，发个财；减个肥，瘦2斤；做2020最幸福的仔！',
			'加个薪，恋个爱； 2020甜蜜生活全都属于你！',
			'2019趟过生活的长河，回头时仍是满脸阳光的勇敢少年！',
			'不用怀疑生活曾给过的辛苦，毕竟2020你将一夜暴富！',
			'2020依旧年轻的你，加油向前奔跑吧！',
			'不熬夜、少喝酒，2020让生活健康点，不好吗？',
			'2019在幸福中结束了，2020会有更多的惊喜等着你哦！',
			'生活不止熬夜、打游戏，还有保温杯里的枸杞！'
		]
	},
	mutations: {
		// 设置是否在app中
		appFlag(state, flag) {
			state.isApp = flag
		},
		setVersionSize(state, num) {
			state.versionSize = num
		},
		setServerTime(state, time) {
			state.serverTime = time
		},
		setToastData(state, data) {
			state.toastData = data
		},
		setPageLoading(state, flag) {
			state.pageLoading = flag
		},
		setIsImmerse(state, flag) {
			state.isImmerse = flag
		},
		getActivityData(state, data) {
			state.activityData = data
		},
		// 设置用户信息
		getUserinfo(state, data) {
			state.userinfo = {
        ...data,
        origin: 'app'
      }
		},
		// 设置分享数据
		setshareData(state, data) {
			state.shareData = data
		},
		// 设置弹窗数据
		setMaskData(state, data) {
			state.maskData = data
		},
		// 设置获得红包弹窗是否显示
		sethbFlagData(state, data) {
			state.hbFlagData = data
		},
		// 设置结果页数据
		setResultData(state, data) {			
			state.resultData = data
		}
	},
	actions: {
		// 设置是否在app中
		appFlagAsync ({ commit, state }, flag) {
			commit('appFlag', flag)
		},
		setVersionSizeAsync({ commit, state }, num) {
			commit('setVersionSize', num)
		},
		setServerTimeAsync({ commit, state }, time) {
			commit('setServerTime', time)
		},
		getActivityDataAsync({ commit, state }, data) {
			commit('getActivityData', data)
		},
		// 获取用户信息
		getUserinfoAsync ({ commit, state }) {
			if(COVERAPP.Attribute.isApp()) {
				COVERAPP.Method.GetUser({
					callback(res) {
						let userinfo = JSON.parse(res);
						if(!COVER.isEmpty(userinfo.user_id)){
							if (COVERAPP.Attribute.isIOS()) {
								if (parseInt(state.versionSize) >= 450) {
									userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)));
								}
							}
							sessionStorage.setItem('COVER_USERINFO', JSON.stringify(userinfo))
							commit('getUserinfo', userinfo)
						}
					}
				})
			} else {
				COVER.getUser((res) => {
					commit('getUserinfo', JSON.parse(JSON.stringify(res)))
				})
			}      
		},
		// 设置分享数据
		setshareDataAsync ({ commit, state }, data) {
			commit('setshareData', data)
		},
		// 设置弹窗数据
		setMaskDataAsync ({ commit, state }, data) {
			commit('setMaskData', data)
		},
		setToastDataAsync({ commit, state }, data) {
			commit('setToastData', data)
		},
		setPageLoadingAsync({ commit, state }, flag) {
			commit('setPageLoading', flag)
		},
		setIsImmerseAsync({ commit, state }, flag) {
			commit('setIsImmerse', flag)
		},
		// 检查是否能领取红包
		checkCanGetHb({ commit, state }, type) {
			return new Promise((resolve, reject) => {
        const origin = type == 2 ? 'share' : 'dynamic';
				COVER.$post('/lottery/query/count', {
          aid: state.aid,
          userinfo: state.userinfo,
          origin,
				}, "POST").then((res) => {
          return resolve(res);
          if(res.errno == 0) {
						return resolve(res);
					}

          if (res.errno === 2002 || res.errno === 2003) {
            if (origin === 'dynamic') {
              commit('setToastData', {
                text: '亲，今日发动态获得红包已经领取，明天再来吧！'
              });
              return;
            }

            if (origin === 'share') {
              commit('setToastData', {
                text: '亲，今日分享获得红包已经领取，明天再来吧！'
              });
              return;
            }
          }

          if (res.errno === 2005 || res.errno === 2006 || res.errno === 2004) {
            /* commit('setToastData', {
              text: '亲，今日已参与抽奖，明天再来吧！'
            }); */
            return reject();
          }

          commit('setToastData', {
            text: res.errmsg || '网络错误~',
          });
				}).catch((err) => {
					commit('setToastData', {
						text: '加载失败，请重试！'
					})
				})
			})
		},
		// 获得红包
		getHbAsync ({ commit, state }, type) {
			let hbUserInfo = JSON.parse(JSON.stringify(state.userinfo));
			hbUserInfo.nickname = window.btoa(unescape(encodeURIComponent(hbUserInfo.nickname)))
			COVER.$request('/lottery/luck', {
				aid: state.aid,
				userinfo: hbUserInfo,
        origin: type == 2 ? 'share' : 'dynamic'
      }, "POST").then((res) => {
        if(res.errno == 0 && res.data) {
          commit('sethbFlagData', {
            type,
						id: res.data.pid
					});
          return;
        }

        const info = (type == 2) ? {
          tag: Math.floor(Math.random() * 9),
        } : {
          year: type == 0 ? 2019 : 2020,
          tag: Math.floor(Math.random() * 9),
        };
        console.log(info);
        commit('setResultData', {
          info,
        });
        setTimeout(() => {
          router.replace('/result');
        }, 1000);

        /* commit('setMaskData', {
          type: 4,
          text: res.errmsg ||  '加载失败，请重试！',
          btns: [
            {
              className: 'mask-back-btn',
              text: '确定'
            }
          ]
        }) */
      }).catch((err) => {
				commit('setMaskData', {
					type: 4,
					text: '加载失败，请重试！',
					btns: [
						{
							className: 'mask-back-btn',
							text: '确定'
						}
					]
				})
			})
		},
		// 设置获得红包弹窗是否显示
		setHbShowFlagAsync ({ commit, state }, data) {
			commit('sethbFlagData', data)
		},
		setResultDataAsync ({ commit, state }, data) {
			commit('setResultData', data)
		},
		checkTimeAsync ({ commit, state }, data) {
      return;
			return new Promise((resolve, reject) => {
				COVER.$request('/activity/times', {}).then((res) => {
					let nowTime = 0;
					if(res.errno == 0){
						nowTime = res.data.timestamp;
					}else{
						nowTime = new Date().getTime();
					}
					commit('setServerTime', nowTime)
					resolve()
					if(state.isApp && parseInt(state.versionSize) < 570) {
						return;
					}
					if(nowTime < state.activityData.startTime){
						commit('setMaskData', {
							type: 1,
							text: '亲，红包尚未开启，请在<br/>2020.1.21—2020.1.30时间段内来参与！'
						})
					}else if(nowTime >= state.activityData.endTime){
						commit('setMaskData', {
							type: 2,
							text: '亲，今年抢红包活动已结束，<br/>欢迎明年再来！'
						})
					}
				});
			})
		},
	},
	modules: {
	}
})
